import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ProfilesPage, toProfileTab } from '@/components/profiles/profiles-page';

export const Route = createFileRoute('/profiles/$tab')({
  component: ProfilesTabPage,
});

function ProfilesTabPage() {
  const { tab } = Route.useParams();
  const navigate = useNavigate();
  // A URL naming no tab we have opens the first one rather than a blank page,
  // which is what an old bookmark or a typo deserves.
  return (
    <ProfilesPage
      tab={toProfileTab(tab)}
      onTabChange={(next) => {
        void navigate({ to: '/profiles/$tab', params: { tab: next } });
      }}
    />
  );
}
